import React from 'react';
import '../../styles/AdminPages.css';

const Users = () => {
  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h1>Users Management</h1>
        <p>Manage user accounts and permissions</p>
      </div>
      
      <div className="admin-card">
        <div className="admin-table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Joined</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>
                  No users found
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Users;

